// Interfaces
import { IBaseStepProps } from './interfaces'

// Antd
import { Steps } from 'antd'

// Step
const { Step } = Steps

const BaseStep = ({ title, description, ...rest }: IBaseStepProps) => {
  return <Step title={title} description={description} {...rest} />
}

export { BaseStep }
